import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Navbar from "../navbar/Navbar";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Button from "@material-ui/core/Button";
import Footer from "../footer/footer";
import { Link } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  }
}));

export default function ControlledExpansionPanels() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Navbar />
      <Link to="/Notes" id="back">
        <Button
          style={{ margin: "10px", marginTop: "70px" }}
          variant="contained"
          color="primary"
          href="#contained-buttons"
        >
          <KeyboardBackspaceIcon />
        </Button>
      </Link>
      <h1 id ='desc' style={{ textAlign: "center" }}>Seventh sem CSE/ISE Notes</h1>

      <ExpansionPanel
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        style={{ marginTop: "40px" }}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>
            Storage area network (SAN)
          </Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/1pKhJyUQQVDrI_j6qCXpZ1lAchICAZXp7/view?usp=sharing">
                Module 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1zAb-lJBs8a94nqipOnhzLi8m19qsS-4p/view?usp=sharing">
                Module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1MyET_SJMDMkoJERj0CpWX70Wv_ScKRaX/view?usp=sharing">Module 3 </a>
              <br />
              <a href="https://drive.google.com/file/d/1Ac91cMc2oVxFrJtDmfUkU8RCf5ulaLZC/view?usp=sharing">Module 4 </a>
              <br />
              <a href="">Module 5 (NOT AVAILABLE)</a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className={classes.heading}>
            Advanced computer architecture (ACA)
          </Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            {" "}
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/1yZg8isHBAp1qKux_VAgw_8mC4oCLBmwd/view?usp=sharing">
                Module 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1k0hKx8xbaOebRlFmU58adN2OInSo3rOc/view?usp=sharing">
                Module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1S0Bve-H3DLpjx_0JrkTh4Z4npcRhY-Om/view?usp=sharing">
                Module 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1q-bwYxMjk2WM95ND4vWYPkRgl1zcPfWx/view?usp=sharing">
                Module 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1kwAtvnUzBNmrDS5c63T6qBHIOoPqyCVo/view?usp=sharing">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className={classes.heading}>
            Web technology and its applications (WEB)
          </Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/1ygqc0-iebBlQzT7-aO2Ui9yqp4MwkvDf/view?usp=sharing">
                Module 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1nC6sklCAyP3J-2pzbiPMwNACmvzkbkHm/view?usp=sharing">
                Module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1lrqg6ZQ1wtCFZ27HBDCZjMNDP2CBzv7o/view?usp=sharing">
                Module 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1xy6bePVSVwIlPOO2zPNoCAXDjnuqaHSm/view?usp=sharing">
                Module 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1YTfZVlRXRmDGO6KVbEPAoRS_g2Ej_HF9/view?usp=sharing">Module 5</a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>
            Machine learning (ML)
          </Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/1-XxXSJGp7JbuBfpDFfgUJcYLFYvbpOxP/view">
                Module 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1Xf884SSMoi-ff9aWI-Jx7Hq-_3WXOqAa/view">
                Module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1258GDzZFPiI7Z_5YjxSW5cNnT_GbqRcU/view">
                Module 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1Ii2P2oRTVoFScF1eBZnoA6II2SmWR6ZV/view">
                Module 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1AEW8232G07r_2s_XNARaDomrQrnzLWbp/view">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>
            Unix System Programming
          </Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            {" "}
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              {/* Notes by Prof. Thaseen Taj (DEPT.CSE, DBIT) <br/> */}
              <a href="https://drive.google.com/file/d/1wS3fTDMIQZ7tbN-lmVMRPq76GLbovRpM/view?usp=sharing">
                Module 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1Km615z7JvM4B8aPm2c0MooEafmIGvgbE/view?usp=sharing">
                Module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1C0kPkYLop7BylNuF1lY5SBdX7wqX1iXy/view?usp=sharing">
                Module 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1RU2K88nBIGZS3Wwh_x5pgthnBm9cKAys/view?usp=sharing">
                Module 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1uZRgcusawswIYVhM9kr_t4CXfzaGlW_8/view?usp=sharing">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>INS</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            {" "}
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/14qK68R6U69vdefwV8tMbsLcZLWY2-LL3/view?usp=sharing">
                Module 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1-2EmhaFgVvq1XcMInV2whVF4NGgjrdZT/view?usp=sharing">
                Module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1stQshdzxfZOn-hf11VHm7KfH3g_-fBOi/view?usp=sharing">
                Module 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1s3RaxSXCocQRXGbhu9N0o8c9y3cAH92O/view?usp=sharing">
                Module 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1TzfBhz5m1mUho8WStLwKcTYZYtLFj6Tc/view?usp=sharing">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
     
      <Footer />
    </div>
  );
}
